import taxInitializer from './tax';

function benefitsInitializer() {
  return {
    options: {
      cpp: {
        ympe: 55900,
        aympe: 54440,
        employeeContributionRate: 0.0495,
        employerContributionRate: 0.0495,
        QC: {
          employeeContributionRate: 0.05325,
          employerContributionRate: 0.05325,
        },
      },
      oas: {
        max: 7039.92,
        clawback: 73756,
      },
      ei: {
        rate: 0.0188,
        maxInsurableEarnings: 50800,
        maxEmployeePremium: 955.04,
        maxEmployerPremium: 1337.06,
        QC: {
          rate: 0.0152,
          maxEmployeePremium: 772.16,
          maxEmployerPremium: 1081.02,
        },
      },
      rrsp: {
        limits: {
          2016: 25370,
          2015: 24930,
          2014: 24270,
        },
      },
      tfsa: {
        limits: {
          2009: 5000,
          2013: 5500,
        },
      },
    },
    getOASMax(startAge = 65) {
      return this.options.oas.max * (1 + (0.006 * 12 * (startAge - 65)));
    },
    getOASClawback() {
      return this.options.oas.clawback;
    },
    calculateOAS(netIncome, startAge = 65) {
      const oasMax = this.getOASMax(startAge);
      const clawbackAmount = Math.max(0, (netIncome - this.options.oas.clawback) * 0.15);
      return Math.max(0, oasMax - clawbackAmount);
    },
    getCPPBenefitMax(startAge = 65) {
      const atAge65 = this.options.cpp.aympe * 0.25;
      if (startAge < 65) {
        return (1 - ((65 - startAge) * 0.006 * 12)) * atAge65;
      }

      return (1 + ((startAge - 65) * 0.007 * 12)) * atAge65;
    },
    getYMPE() {
      return this.options.cpp.ympe;
    },
    getAYMPE() {
      return this.options.cpp.aympe;
    },
    getAllContributions(grossIncome, province) {
      const cpp = this.getCPPContribution(grossIncome, province);
      const ei = this.getEmployeeEIPremiums(grossIncome, province);
      return cpp + ei;
    },
    getCPPContribution(grossIncome, province = null) {
      const amountToCalculate = grossIncome > this.getYMPE() ? this.getYMPE() : grossIncome;
      const cppContribution = ((amountToCalculate - 3500) * this.getCPPRate(province)) / 2;
      return Math.max(0, cppContribution);
    },
    getCPPEmployeeRate(province) {
      return (this.options.cpp[province] || this.options.cpp).employeeContributionRate;
    },
    getCPPEmployerRate(province) {
      return (this.options.cpp[province] || this.options.cpp).employerContributionRate;
    },
    getCPPRate(province) {
      return this.getCPPEmployeeRate(province) + this.getCPPEmployerRate(province);
    },
    calculateCPP(grossIncome, startAge = 65) {
      if (grossIncome > this.getYMPE()) { return this.getCPPBenefitMax(startAge); }
      return (this.getCPPBenefitMax(startAge) * grossIncome) / this.getYMPE();
    },
    getEIMaxAnnualInsurableEarnings() {
      return this.options.ei.maxInsurableEarnings;
    },
    getEIRate(province) {
      return (this.options.ei[province] || this.options.ei).rate;
    },
    getEIMaxAnnualEmployeePremium(province) {
      return (this.options.ei[province] || this.options.ei).maxEmployeePremium;
    },
    getEIMaxAnnualEmployerPremium(province) {
      return (this.options.ei[province] || this.options.ei).maxEmployerPremium;
    },
    getEmployeeEIPremiums(grossIncome, province) {
      const amountToCalculate = grossIncome > this.getEIMaxAnnualInsurableEarnings(province) ?
        this.getEIMaxAnnualInsurableEarnings(province)
      :
        grossIncome;
      const premiums = amountToCalculate * this.getEIRate(province);
      return Math.max(premiums, 0);
    },
    getRRSPLimit(year = 2016) {
      return this.options.rrsp.limits[year];
    },
    calculateRRSPRoom(previousYearsIncome, year = 2016) {
      const rrspLimitAsProportionOfIncome = 0.18;
      const limit = previousYearsIncome * rrspLimitAsProportionOfIncome;
      return Math.min(this.getRRSPLimit(year), limit);
    },
    getTFSALimit(year) {
      const yearWhenLimitSet =
        _.findLast(Object.keys(this.options.tfsa.limits), startYear => startYear <= year);
      return this.options.tfsa.limits[yearWhenLimitSet];
    },
    calculateTFSARoom(age, year = new Date().getFullYear()) {
      let tfsaRoom = 0;

      for (let yearCounter = year, ageCounter = age;
        (yearCounter >= 2009) && (ageCounter >= 18);
        yearCounter -= 1, ageCounter -= 1) {
        tfsaRoom += this.getTFSALimit(yearCounter);
      }
      return tfsaRoom;
    },
    calculateTaxCredit(grossIncome, province) {
      if (this.tax) {
        const cppContribution = this.getCPPContribution(grossIncome, province);
        const eiPremiums = this.getEmployeeEIPremiums(grossIncome, province);
        const provTaxRates = this.tax.getProvincialTaxRates(province);
        const taxCreditRate = provTaxRates ? provTaxRates[1].tax : 0;

        return ((cppContribution + eiPremiums) * 0.15) +
          ((cppContribution + eiPremiums) * taxCreditRate);
      }

      return undefined;
    },
    tax: taxInitializer(),
  };
}

angular.module('wbServices').provider('benefits', [function init() {
  this.$get = benefitsInitializer;
  return this;
}]);

export default benefitsInitializer;
